import { useEffect } from 'react';
import { loadFont } from '@/lib/font-loader';

const FONT_SIZE_CLASSES = {
  sm: 'app-font-sm',
  base: 'app-font-base',
  lg: 'app-font-lg',
  xl: 'app-font-xl',
};

function applySettings(user) {
  if (!user) return;

  const root = document.documentElement;

  root.classList.toggle('high-contrast', !!user.highContrast);
  root.classList.toggle('reduce-motion', !!user.reducedMotion);

  Object.values(FONT_SIZE_CLASSES).forEach((cls) => root.classList.remove(cls));
  const fontClass = FONT_SIZE_CLASSES[user.appFontSize] || '';
  if (fontClass) root.classList.add(fontClass);

  if (user.readingFont && user.readingFont !== 'inter') {
    loadFont(user.readingFont);
  }
}

/**
 * Hook to sync accessibility settings from currentUser to the DOM.
 * Call from any component that has access to usePage().props.currentUser.
 */
export function useAccessibilitySync(currentUser) {
  useEffect(() => {
    applySettings(currentUser);
  }, [
    currentUser,
    currentUser?.highContrast,
    currentUser?.reducedMotion,
    currentUser?.appFontSize,
    currentUser?.readingFont,
  ]);
}

/**
 * Wraps the app tree and applies initial accessibility settings.
 * Does NOT subscribe to Inertia navigation (sits above the Inertia tree).
 * Use useAccessibilitySync() inside a layout for live updates.
 */
export default function AccessibilityProvider({ currentUser, children }) {
  useEffect(() => {
    applySettings(currentUser);
  }, [currentUser]);

  return children;
}
